import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `` : `var(--color-${color})`;
};
const SvgInvoiceIcon = ({ title, theme = null, titleId = "", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 64 64"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M55 2H9a2 2 0 0 0-2 2v57a1 1 0 0 0 1.53.848L16 57.18l7.47 4.668a1 1 0 0 0 1.06 0L32 57.18l7.47 4.668a1 1 0 0 0 1.06 0L48 57.18l7.47 4.668A1 1 0 0 0 57 61V4a2 2 0 0 0-2-2ZM34 45H18a1 1 0 0 1 0-2h16a1 1 0 0 1 0 2Zm0-8H18a1 1 0 0 1 0-2h16a1 1 0 0 1 0 2Zm-2-9a8 8 0 1 1 8-8 8 8 0 0 1-8 8Zm14 17h-4a1 1 0 0 1 0-2h4a1 1 0 0 1 0 2Zm0-8h-4a1 1 0 0 1 0-2h4a1 1 0 0 1 0 2Z"
      fill="currentColor"
    />
  </svg>
);
export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}
const SvgInvoiceStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgInvoiceIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const InvoiceIcon: any = SvgInvoiceStyle;
export default InvoiceIcon;
